/**
 * Where the API lives. One answer, in one place.
 *
 * This exists because there were previously two answers. The app is
 * configured with REACT_APP_API_URL - that is what .env sets and what
 * render.yaml declares - but thirty-one call sites read a second variable,
 * REACT_APP_BACKEND_URL, which was never defined anywhere.
 *
 * The failure was quiet in two different ways, which is why it survived so
 * long. Files written as `process.env.REACT_APP_BACKEND_URL` built URLs
 * beginning with the literal string "undefined". Files written with a
 * `|| ''` fallback looked more careful but were worse: they produced
 * same-origin paths like "/api/ads/feed", which the static host answers with
 * index.html, so the caller got a 200 full of HTML and failed on parsing it -
 * "Unexpected token '<'". Neither reads as a configuration problem.
 *
 * Deliberately dependency-free so that anything can import it, including
 * lib/api.js itself, with no risk of a cycle.
 */

// REACT_APP_BACKEND_URL is still read so that an environment configured the
// old way keeps working. It should not be set in new ones.
const RESOLVED =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  '';

if (!RESOLVED && process.env.NODE_ENV !== 'test') {
  console.error(
    'REACT_APP_API_URL is not set. Create a .env in frontend/ containing: ' +
    'REACT_APP_API_URL=http://localhost:8000'
  );
}

/**
 * The API origin, with no trailing slash and no /api suffix - call sites
 * append their own path, and every one of them writes `/api/...`.
 */
export const API_ORIGIN = (RESOLVED || 'http://localhost:8000').replace(/\/+$/, '');

/** The API root, for callers that want it prebuilt. */
export const API_ROOT = `${API_ORIGIN}/api`;
